import {
  Country,
  getCountries,
} from '@crm-in-store/mist-communication-culture';
import { getCrmisFeatureFlags } from '@crm-in-store/crmis-feature-flags';

const getMemberShipAndLoyaltyCountries = (): Promise<Country[]> => {
  return Promise.all([getCountries(), getCrmisFeatureFlags()]).then(
    ([countries, flags]) => {
      if (!flags || !flags.membershipAndLoyalty) return [];
      if (flags.membershipAndLoyalty === true) {
        return countries;
      } else {
        return countries.filter((country) =>
          (flags.membershipAndLoyalty as string[]).includes(country.code)
        );
      }
    }
  );
};

export default getMemberShipAndLoyaltyCountries;
